import { create } from 'zustand';

/**
 * useTourStore — guided-tour state slice (Plan 05-03 / NAV-05).
 *
 * Pure data store; the real EXIT_TOUR dispatch lives in TourRig via useNavSend
 * (NavContext). TourMenu sets activeTourId via setActiveTour when user clicks
 * a tour entry; TourRig drives setActiveCaption as elapsed crosses each
 * step.triggerAtT threshold; clearTour resets on tour exit.
 *
 * Shape:
 *   - activeTourId: string | null — id of the currently-playing tour
 *   - stepIndex: number — last-fired step index (-1 = no caption yet)
 *   - activeCaption: string | null — text shown in CaptionOverlay
 *
 * setActiveCaption increments stepIndex so the store tracks how many caption
 * events have fired without TourRig having to pass an explicit index. This
 * keeps the caption-trigger loop's bookkeeping in the store rather than in
 * the rig.
 */
interface TourStore {
  activeTourId: string | null;
  stepIndex: number;
  activeCaption: string | null;
  setActiveTour: (tourId: string) => void;
  setActiveCaption: (caption: string) => void;
  clearTour: () => void;
}

export const useTourStore = create<TourStore>((set) => ({
  activeTourId: null,
  stepIndex: -1,
  activeCaption: null,
  setActiveTour: (tourId) =>
    set({ activeTourId: tourId, stepIndex: -1, activeCaption: null }),
  setActiveCaption: (caption) =>
    set((state) => ({
      activeCaption: caption,
      stepIndex: state.stepIndex + 1,
    })),
  clearTour: () =>
    set({ activeTourId: null, stepIndex: -1, activeCaption: null }),
}));
